import { Component, NgZone, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';

@Component({
  selector: 'app-trade-request-recieved',
  templateUrl: './trade-request-recieved.component.html',
  styleUrls: ['./trade-request-recieved.component.css']
})
export class TradeRequestRecievedComponent implements OnInit {
  type = "trade";
  public seller_id;
  pageSize = 10;
  pageNo = 1;
  loading: Boolean = true;
  mainLoader;
  recieveBidLength;
  recieveBidList;
  user_id;
  ID;
  allCategories;
  categoryId = 0;

  modalRef: BsModalRef;
  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 5000
  }

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private http: Http) { }

  ngOnInit() {

    this.mainLoader = '../../assets/images/BigLoader.gif';


    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
    }
    setTimeout(() => {
      this.bidList();
    }, 1000);
  }

  /**
* Function to get List
* @param seller_id 
* @param category_id 
*/
  public bidList() {
    this.loading = true;
    let param = {
      limit: this.pageSize,
      offset: 0,
      receiver_id : this.user_id
    }
    this.advtService.recievedTrade(param)
      .subscribe(data => {
        this.recieveBidList = data.result;
        this.recieveBidLength = data.count;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
      });
  }

  /**
  * This function is used for pagination
  * @param data
  */
  pagingAgent(data) {
    this.loading = true;
    this.recieveBidList = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;
    let param = {
      limit: this.pageSize,
      offset:this.pageNo,
      receiver_id : this.user_id
    }
    this.recieveBidList = [];
    this.advtService.recievedTrade(param)
      .subscribe(data => {
        window.scrollTo(0, 0);
        this.recieveBidList = data.result;
        this.loading = false;

      });
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/trade/trade-request-recieved/trade-request-recieved.component.ts